module.exports = __webpack_public_path__ + "static/img/banner.6141f01.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/about/banner.png
// module id = 51xV
// module chunks = 1